import { render, staticRenderFns } from "./allocate.vue?vue&type=template&id=106f8963&scoped=true&"
import script from "./allocate.vue?vue&type=script&lang=js&"
export * from "./allocate.vue?vue&type=script&lang=js&"
import style0 from "./allocate.vue?vue&type=style&index=0&id=106f8963&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106f8963",
  null
  
)

export default component.exports